import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { Close } from "@mui/icons-material"
import { Grid, IconButton } from "@mui/material"
import { StandardDialog } from "../../../../dialogs/StandardDialog"

const useStyles = makeStyles()((_theme) => ({
    dialogContainer: {
        position: "relative",
        "& >img": {
            width: "100%",
            height: "auto",
            objectFit: "cover",
        },
    },

    closeIcon: {
        position: "absolute",
        right: "1.75rem",
        top: "1rem",
        color: "white",
        padding: "0.3rem",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
    },
    previewPaperSlot: {
        overflow: "hidden",
    },
    hideEdge: { display: "none" },
}))

type ResourceBookingPreviewImageProps = Readonly<{
    previewImage: string | null
    handleClose: () => void
}>

export const ResourceBookingPreviewImage = memo(({ previewImage, handleClose }: ResourceBookingPreviewImageProps) => {
    const { classes } = useStyles()

    return (
        <>
            <StandardDialog
                open={!!previewImage}
                topbar={<></>}
                onClose={handleClose}
                updateEdge={classes.hideEdge}
                slotProps={{
                    paper: { className: classes.previewPaperSlot },
                }}
            >
                <Grid container className={classes.dialogContainer}>
                    <IconButton edge="end" size="large" onClick={handleClose} className={classes.closeIcon}>
                        <Close fontSize="inherit" />
                    </IconButton>
                    <img src={`${previewImage}`} alt="product image" onError={handleClose} />
                </Grid>
            </StandardDialog>
        </>
    )
})
